import script from "./CTournamentsNotAvailable.vue?vue&type=script&setup=true&lang=ts"
export * from "./CTournamentsNotAvailable.vue?vue&type=script&setup=true&lang=ts"

import "./CTournamentsNotAvailable.vue?vue&type=style&index=0&id=55f24133&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55f24133"]])

export default __exports__